import { createContext, useContext, useState } from "react";

const NavigationContext = createContext<any>(null);

export const useNavigationContext = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};

export const NavigationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isBack, setIsBack] = useState(false);
  return (
    <NavigationContext.Provider value={{ isBack, setIsBack }}>
      {children}
    </NavigationContext.Provider>
  );
};
